import { FC } from 'react';

export const Spinner: FC = () => (
  <div className="h-100">
    <div>
      <div className="taste-advisor-spinner-small">
        <div className="loader" />
      </div>
    </div>
  </div>
);
